import React from 'react'

import Card from 'react-bootstrap/Card'

import ReactMarkdown from 'react-markdown'
import gemoji from 'remark-gemoji'

export default function IconFlexbox(props) {

    const triggerCallback = (event) => {
        var target = event.target;

        if (target == null) {
            console.warn("target of click event is null");
            return;
        }

        var code = target.getAttribute('data-code');

        if (code !== undefined) {
            if (props.clickCallback != null) {
                props.clickCallback(code);
            } else {
                console.warn("no callback present!");
            }
        } else {
            console.warn("code data attribute not present.");
        }
    }

    return (
        <div className="emoji-flex-panel">
            {
                props.emotes.map((emoji, index) => {
                    return <Card key={index} data-code={emoji} onClick={(x) => triggerCallback(x)}><ReactMarkdown plugins={[gemoji]}>{emoji}</ReactMarkdown></Card>
                })
            }
        </div>
    )
}
